module.exports = __webpack_public_path__ + "static/media/apex.fbf3ca16.jpg";